import FinanceXBankAccounts from './FinanceXBankAccounts.container';

export default FinanceXBankAccounts;
